import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { scrollToSection } from '../utils/commonUtils';
import logo from '../assets/images/IA_LOGO.svg';

// 네비게이션 메뉴 리스트
const NAV_ITEMS = [
  { id: 'hero', label: 'Home' },
  { id: 'company-section2', label: 'Company' },
  { id: 'solution', label: 'Solutions' },
  { id: 'blog', label: 'Blog' },
  { id: 'news', label: 'News' },
];

export default function Navbar() {
  const { i18n } = useTranslation();
  const { t }: { t: (key: string) => string } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  // 언어 변경 시 마다 상태를 업데이트하는 상태 관리
  const [currentLang, setCurrentLang] = useState('');

  // 컴포넌트 마운트 시 초기 언어 설정
  useEffect(() => {
    // 컴포넌트가 마운트될 때 현재 i18n 언어 가져오기
    setCurrentLang(i18n.language.substring(0, 2));

    // 언어 변경 이벤트 리스너
    const handleLanguageChanged = (lng: string) => {
      setCurrentLang(lng.substring(0, 2));
    };

    i18n.on('languageChanged', handleLanguageChanged);

    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  return (
    <header className="h-[96px] bg-white sticky top-0 z-50 shadow-md flex items-center">
      <nav className="w-full max-w-[1280px] mx-auto px-6 py-4 flex justify-between items-center h-full">
        <div className="flex items-center flex-grow">
          <div
            className="flex items-center justify-center cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <img src={logo} alt="Logo" className="w-14 my-2" />
          </div>

          <ul className="hidden md:flex text-lg space-x-4 md:space-x-6 lg:space-x-8 ml-10">
            {NAV_ITEMS.map(({ id, label }) => (
              <li
                key={id}
                className="cursor-pointer hover:text-primary duration-300"
                onClick={() => scrollToSection(id)}
              >
                {label}
              </li>
            ))}
          </ul>
        </div>

        <div className="hidden md:flex gap-4 items-center ml-6">
          <div className="flex gap-4 items-center">
            <button
              onClick={() => changeLanguage('ko')}
              className={`px-1 py-1 text-lg transition-colors duration-150 ${
                currentLang === 'ko' ? 'text-primary' : 'text-gray-500'
              }`}
            >
              KO
            </button>
            <span className="opacity-30 text-xl">|</span>
            <button
              onClick={() => changeLanguage('en')}
              className={`px-1 py-1 text-lg transition-colors duration-150 ${
                currentLang === 'en' ? 'text-primary' : 'text-gray-500'
              }`}
            >
              EN
            </button>
          </div>
          <a
            href={`mailto:consult@iacloud.kr?subject=${t('Contact.emailSubject')}&body=${t('Contact.emailBody')}`}
            className="text-center rounded-sm px-6 py-3 text-lg font-bold transition duration-150 bg-primary text-white cursor-pointer hover:bg-primary-400"
          >
            CONTACT
          </a>
        </div>

        {/* 모바일 navbar */}
        <button
          className="md:hidden text-gray-800 focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <FontAwesomeIcon icon={faBars} className="w-8 h-8" />
        </button>
      </nav>

      <div
        className={`md:hidden fixed inset-0 bg-black bg-opacity-50 z-50 ${
          isOpen ? 'flex' : 'hidden'
        } justify-end`}
      >
        <div className="w-64 bg-white h-full shadow-lg p-6 flex flex-col">
          <button className="self-end text-gray-800" onClick={() => setIsOpen(false)}>
            <FontAwesomeIcon icon={faXmark} className="w-8 h-8" />
          </button>

          <ul className="mt-8 space-y-6 text-lg">
            {NAV_ITEMS.map(({ id, label }) => (
              <li
                key={id}
                className="cursor-pointer hover:text-primary duration-300"
                onClick={() => {
                  scrollToSection(id);
                  setIsOpen(false);
                }}
              >
                {label}
              </li>
            ))}
          </ul>

          <div className="mt-auto flex flex-col gap-4 border-t pt-4">
            <div className="flex justify-center gap-4 items-center">
              <button
                onClick={() => changeLanguage('ko')}
                className={`px-1 py-1 text-lg transition-colors duration-150 ${
                  currentLang === 'ko' ? 'text-primary' : 'text-gray-500'
                }`}
              >
                KO
              </button>
              <span className="opacity-30 text-xl">|</span>
              <button
                onClick={() => changeLanguage('en')}
                className={`px-1 py-1 text-lg transition-colors duration-150 ${
                  currentLang === 'en' ? 'text-primary' : 'text-gray-500'
                }`}
              >
                EN
              </button>
            </div>
            <a
              href={`mailto:consult@iacloud.kr?subject=${t('Contact.emailSubject')}&body=${t('Contact.emailBody')}`}
              className="text-center rounded-sm px-6 py-3 text-sm font-bold transition duration-150 bg-primary text-white cursor-pointer hover:bg-primary-400"
            >
              CONTACT
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
